import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useDisableServiceAccount, useEnableServiceAccount } from "../../hooks/use-service-accounts";
import { ServiceAccount } from "../../service-accounts.type";

interface ToggleEnabledButtonProps {
  serviceAccount: ServiceAccount;
}

export const ToggleEnabledButton = ({ serviceAccount }: ToggleEnabledButtonProps) => {
  const { enableServiceAccount, loading: enableLoading } = useEnableServiceAccount(serviceAccount.id);
  const { disableServiceAccount, loading: disableLoading } = useDisableServiceAccount(serviceAccount.id);

  const loading = enableLoading || disableLoading;

  const handleToggle = async () => {
    try {
      if (serviceAccount.enabled) {
        await disableServiceAccount();
        toast.success("Compte de service désactivé", { style: { color: "#228B22" } });
      } else {
        await enableServiceAccount();
        toast.success("Compte de service activé", { style: { color: "#228B22" } });
      }
    } catch {
      toast.error("Une erreur s'est produite");
    }
  };

  if (loading) {
    return <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />;
  }

  return (
    <button
      className="cursor-pointer bg-transparent border-none p-0"
      onClick={(e) => {
        e.stopPropagation();
        handleToggle();
      }}
      type="button"
    >
      {serviceAccount.enabled ? "Désactiver" : "Activer"}
    </button>
  );
};
